import { render } from "./CardPrivilegesCategoryItem.vue?vue&type=template&id=63405281&scoped=true"
import script from "./CardPrivilegesCategoryItem.vue?vue&type=script&lang=js"
export * from "./CardPrivilegesCategoryItem.vue?vue&type=script&lang=js"

import "./CardPrivilegesCategoryItem.vue?vue&type=style&index=0&id=63405281&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63405281"]])

export default __exports__